<div [class]="styleClass === undefined ? 'main-ri-shi-container' : styleClass">
    <div class="sera-ri-shi-label-container">
        <p class="sera-ri-shi-label">{{ label }}</p>
    </div>
    <div class="sera-ri-shi-value-container">
        <p
            class="sera-ri-shi-value"
            *ngIf="!hideValue">
            {{ value | number : '1.1-1' }}
        </p>
        <div class="sera-ri-shi-circles-container">
            <div class="sera-ri-shi-circle {{ color === 'GREEN' ? 'sera-ri-shi-circle-green' : '' }}"></div>
            <div class="sera-ri-shi-circle {{ color === 'YELLOW' ? 'sera-ri-shi-circle-yellow' : '' }}"></div>
            <div class="sera-ri-shi-circle {{ color === 'RED' ? 'sera-ri-shi-circle-red' : '' }}"></div>
        </div>
    </div>
</div>
